import Main from './Main'

export default {
  Main
}



// WEBPACK FOOTER //
// ./src/components/Community/Application/index.js